module.exports = __webpack_public_path__ + "img/montant-comptes.77c9538e.png";